var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-table",
    {
      staticClass: "table-responsive-xl resolution_table",
      attrs: {
        "head-variant": "dark",
        "thead-class": _vm.head_class,
        "tbody-tr-class": _vm.rowClass,
        busy: _vm.is_load,
        striped: "",
        items: _vm.items,
        fields: _vm.fields,
      },
      scopedSlots: _vm._u(
        [
          {
            key: "thead-top",
            fn: function (data) {
              return !_vm.show_head
                ? [
                    _c("tr", { staticClass: "info" }, [
                      _c(
                        "td",
                        { staticClass: "title_type", attrs: { colspan: "6" } },
                        [_vm._v(_vm._s(_vm.title))]
                      ),
                    ]),
                  ]
                : undefined
            },
          },
          {
            key: "cell(cur_action)",
            fn: function (data) {
              return [
                _c("span", { domProps: { innerHTML: _vm._s(data.value) } }),
              ]
            },
          },
          {
            key: "cell(name)",
            fn: function (data) {
              return [
                _c("div", { staticClass: "u_fio" }, [
                  _vm._v(_vm._s(data.item.name)),
                ]),
                _vm._v(" "),
                _c("vacation", { attrs: { id: parseInt(data.item.user_id) } }),
              ]
            },
          },
          {
            key: "cell(user_image)",
            fn: function (data) {
              return [
                data.item.hasOwnProperty("user_image")
                  ? _c("img", {
                      staticClass: "user_avatar rounded-circle pointer",
                      attrs: { src: data.item.user_image },
                      on: {
                        click: function ($event) {
                          return _vm.click_photo(data.item.user_id)
                        },
                      },
                    })
                  : _vm._e(),
              ]
            },
          },
          {
            key: "cell(cur_right)",
            fn: function (data) {
              return [
                _vm.is_edit(data.item)
                  ? _c(
                      "div",
                      {
                        staticClass: "big_click",
                        on: { click: data.toggleDetails },
                      },
                      [_c("fa", { attrs: { icon: _vm.faTools } })],
                      1
                    )
                  : _vm._e(),
              ]
            },
          },
          {
            key: "cell(act_date)",
            fn: function (data) {
              return [
                _c("div", { domProps: { innerHTML: _vm._s(data.value) } }),
                _vm._v(" "),
                _c("doc_watch", {
                  attrs: {
                    u_type: _vm.type,
                    doc_id: parseInt(data.item.mem_id),
                    user_id: parseInt(data.item.user_id),
                  },
                }),
              ]
            },
          },
          {
            key: "row-details",
            fn: function (row) {
              return [
                _c(
                  "b-card",
                  [_c("admineditor", { attrs: { row: row.item } })],
                  1
                ),
              ]
            },
          },
        ],
        null,
        true
      ),
    },
    [
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "text-center text-danger my-2",
          attrs: { slot: "table-busy" },
          slot: "table-busy",
        },
        [
          _c("b-spinner", { staticClass: "align-middle" }),
          _vm._v(" "),
          _c("strong", [_vm._v("Завантаження...")]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }